module.exports = __webpack_public_path__ + "img/Background6.77d37bca.jpg";